module.exports = __webpack_public_path__ + "img/KM360P.707d41aa.png";